// extracted by mini-css-extract-plugin
export default {"container":"MobileAboutUsPage_container__DHaoH","img":"MobileAboutUsPage_img__FY0yN"};